import {Action, Condition, DataPolicy, ItemType, PolicySpec, SchemaPolicy} from 'auth/PolicyConstants';
import {
  SchemaPoliciesQuery,
  SchemaPoliciesQueryVariables,
} from 'collaborator-components/__generated/SchemaPoliciesQuery';
// @ts-expect-error
// eslint-disable-next-line unused-imports/no-unused-imports
import SchemaCollaboratorsSection from 'collaborator-components/SchemaCollaboratorsSection';
import {SCHEMA_POLICIES_QUERY} from 'collaborator-components/useSchemaPoliciesListing';
import {
  ActionOptionGroupNode,
  ActionOptionNode,
  ConditionOptionNode,
  PolicyAction,
  PolicyCondition,
  PolicyItemType,
  PolicyTemplateNode,
} from 'graphql-client/__generated/graphqlGlobalTypes';
import {makeTypesafeQueryMock} from 'test/lib/MockGraphQLProvider';
import {PartyInputQuery, PartyInputQueryVariables} from 'ui-library/entity-input/__generated/PartyInputQuery';
import {PARTY_INPUT_QUERY} from 'ui-library/entity-input/EntityInputConstants';

type SchemaPolicyListingPermissions =
  SchemaPoliciesQuery['schemaPolicyListing']['schemaPolicies'][number]['permissions'];

const WRITABLE_PERMISSIONS: SchemaPolicyListingPermissions = {__typename: 'PermissionsNode', writable: true};

const READ_POLICY_STATEMENTS = [
  {
    action: Action.READ,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
];

export const READ_POLICY = {
  id: 'datapol_1',
  name: 'Read',
  isDefault: true,
  isAdmin: false,
  isHidden: false,
  policyStatements: READ_POLICY_STATEMENTS,
  permissions: WRITABLE_PERMISSIONS,
};

export const READ_POLICY_SPEC: PolicySpec = {
  statements: READ_POLICY_STATEMENTS,
  name: READ_POLICY.name,
};

export const READ_POLICY_HIDDEN = {
  ...READ_POLICY,
  id: 'datapol_1h',
  name: 'Read (Hidden)',
  isHidden: true,
};

const APPEND_POLICY_STATEMENTS = [
  {
    action: Action.APPEND,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
];

export const APPEND_POLICY = {
  id: 'datapol_WgPyaN6o',
  name: 'Append',
  isDefault: false,
  isAdmin: false,
  isHidden: true,
  policyStatements: APPEND_POLICY_STATEMENTS,
  permissions: WRITABLE_PERMISSIONS,
};

export const APPEND_POLICY_SPEC = {
  statements: APPEND_POLICY_STATEMENTS,
  name: APPEND_POLICY.name,
  id: APPEND_POLICY.id,
};

const WRITE_POLICY_STATEMENTS = [
  {
    action: Action.WRITE,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.EDIT_POLYMER_FEATURES,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.CREATE_SUBFOLDER,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
];

export const WRITE_POLICY = {
  id: 'datapol_2',
  name: 'Write',
  isDefault: false,
  isAdmin: false,
  isHidden: false,
  policyStatements: WRITE_POLICY_STATEMENTS,
  permissions: WRITABLE_PERMISSIONS,
};

export const WRITE_POLICY_SPEC = {
  statements: WRITE_POLICY_STATEMENTS,
  name: WRITE_POLICY.name,
  id: WRITE_POLICY.id,
};

const ADMIN_POLICY_STATEMENTS = [
  {
    action: Action.ADMIN,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.NOTEBOOK,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.LOCATION,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.OTHER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.EDIT_POLYMER_FEATURES,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BIOENTITY,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BATCH,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.CREATE_SUBFOLDER,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.FOLDER_OR_PROJECT,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.BOX,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.APPEND,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.PLATE,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.ADMIN,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.WRITE,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
  {
    action: Action.READ,
    itemType: ItemType.CONTAINER,
    condition: Condition.ALWAYS,
  },
];

export const CUSTOM_POLICY = {
  id: 'datapol_cUsTom',
  name: 'Custom',
  isDefault: false,
  isAdmin: false,
  isHidden: false,
  policyStatements: [],
  permissions: WRITABLE_PERMISSIONS,
};

export const ADMIN_POLICY = {
  id: 'datapol_3',
  name: 'Admin',
  isDefault: false,
  isAdmin: true,
  isHidden: false,
  policyStatements: ADMIN_POLICY_STATEMENTS,
  permissions: WRITABLE_PERMISSIONS,
};

export const ADMIN_POLICY_SPEC = {
  statements: ADMIN_POLICY_STATEMENTS,
  name: ADMIN_POLICY.name,
  id: ADMIN_POLICY.id,
};

export const DATA_POLICIES: Array<DataPolicy> = [READ_POLICY, APPEND_POLICY, WRITE_POLICY, ADMIN_POLICY];
export const VISIBLE_DATA_POLICIES: Array<DataPolicy> = [READ_POLICY, WRITE_POLICY, ADMIN_POLICY];

export const SCHEMA_READ_POLICY = {
  id: 'schempol_read',
  name: 'Read',
  isHidden: false,
  policyStatements: [
    {
      action: Action.READ,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.READ,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.APPEND,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
  ],
  permissions: WRITABLE_PERMISSIONS,
};

export const SCHEMA_WRITE_POLICY = {
  id: 'schempol_write',
  name: 'Write',
  isHidden: false,
  policyStatements: [
    {
      action: Action.WRITE,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.READ,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.APPEND,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.WRITE,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
  ],
  permissions: WRITABLE_PERMISSIONS,
};

export const SCHEMA_CREATE_POLICY = {
  id: 'schempol_create',
  name: 'Create',
  isHidden: false,
  policyStatements: [
    {
      action: Action.LIST_DEFINITION,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.READ,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.CREATE,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.REGISTER,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
  ],
  permissions: WRITABLE_PERMISSIONS,
};

export const SCHEMA_ADMIN_POLICY = {
  id: 'schempol_admin',
  name: 'Admin',
  isHidden: false,
  policyStatements: [
    {
      action: Action.READ,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.WRITE,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.ADMIN,
      itemType: ItemType.SCHEMA,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.READ,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.APPEND,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.WRITE,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
    {
      action: Action.ADMIN,
      itemType: ItemType.REGISTRY,
      condition: Condition.ALWAYS,
    },
  ],
  permissions: WRITABLE_PERMISSIONS,
};

export const SCHEMA_POLICIES: Array<SchemaPolicy> = [
  SCHEMA_READ_POLICY,
  SCHEMA_WRITE_POLICY,
  SCHEMA_CREATE_POLICY,
  SCHEMA_ADMIN_POLICY,
];

export const SCHEMA_POLICIES_MOCK = makeTypesafeQueryMock<SchemaPoliciesQuery, SchemaPoliciesQueryVariables>({
  query: SCHEMA_POLICIES_QUERY,
  data: {
    schemaPolicyListing: {
      __typename: 'SchemaPolicyListingNode',
      schemaPolicies: [
        {
          ...SCHEMA_READ_POLICY,
          __typename: 'SchemaPolicyNode',
          policyStatements: [],
          permissions: WRITABLE_PERMISSIONS,
        },
        {
          ...SCHEMA_CREATE_POLICY,
          __typename: 'SchemaPolicyNode',
          policyStatements: [],
          permissions: WRITABLE_PERMISSIONS,
        },
        {
          ...SCHEMA_ADMIN_POLICY,
          __typename: 'SchemaPolicyNode',
          policyStatements: [],
          permissions: WRITABLE_PERMISSIONS,
        },
      ],
    },
  },
  variables: {
    limitOffsetInput: {
      limit: 3,
      offset: 0,
    },
  },
});

const PARTY_QUERY_MOCK = makeTypesafeQueryMock<PartyInputQuery, PartyInputQueryVariables>({
  query: PARTY_INPUT_QUERY,
  data: {
    parties: [],
  },
  variables: {ids: []},
});

export const SCHEMA_POLICIES_LISTING_MOCKS = [SCHEMA_POLICIES_MOCK, PARTY_QUERY_MOCK];

export const ALWAYS_CONDITION_OPTION: ConditionOptionNode = {
  __typename: 'ConditionOptionNode',
  condition: PolicyCondition.ALWAYS,
  name: 'Granted',
};

export const IS_AUTHOR_CONDITION_OPTION: ConditionOptionNode = {
  __typename: 'ConditionOptionNode',
  condition: PolicyCondition.IS_AUTHOR,
  name: 'Granted to author',
};

export const mockActionOption = (
  action: PolicyAction,
  name: string,
  conditionOptions: Array<ConditionOptionNode>,
  description: string | null = null
): ActionOptionNode => ({
  __typename: 'ActionOptionNode',
  action,
  name,
  description,
  conditionOptions,
  disabled: true,
  itemTypeOverride: null,
});

export const READ_ACTION_OPTION = mockActionOption(PolicyAction.READ, 'View', [ALWAYS_CONDITION_OPTION]);

export const EDIT_ACTION_OPTION_GROUP: ActionOptionGroupNode = {
  __typename: 'ActionOptionGroupNode',
  name: 'Edit',
  description: null,
  actionOptions: [
    mockActionOption(
      PolicyAction.WRITE,
      'Write action',
      [ALWAYS_CONDITION_OPTION, IS_AUTHOR_CONDITION_OPTION],
      'This action is in an action group'
    ),
  ],
};

export const DATA_POLICY_TEMPLATE: PolicyTemplateNode = {
  __typename: 'PolicyTemplateNode',
  itemTypeOptions: [
    {
      __typename: 'ItemTypeOptionNode',
      itemType: PolicyItemType.FOLDER_OR_PROJECT,
      name: 'Projects and folders ItemTypeOption',
      description: null,
      actionOptions: [READ_ACTION_OPTION, EDIT_ACTION_OPTION_GROUP],
    },
  ],
};

export const DETAILED_DATA_POLICY_TEMPLATE: PolicyTemplateNode = {
  __typename: 'PolicyTemplateNode',
  itemTypeOptions: [
    {
      __typename: 'ItemTypeOptionNode',
      itemType: PolicyItemType.NOTEBOOK,
      name: 'Notebook entries',
      description: null,
      actionOptions: [
        READ_ACTION_OPTION,
        {
          __typename: 'ActionOptionGroupNode',
          name: 'Edit',
          description: null,
          actionOptions: [
            mockActionOption(PolicyAction.EDIT_SCHEMA_AND_FIELDS, 'Edit entry schema and fields', [
              ALWAYS_CONDITION_OPTION,
              IS_AUTHOR_CONDITION_OPTION,
            ]),
            mockActionOption(
              PolicyAction.WRITE,
              'Edit other data',
              [ALWAYS_CONDITION_OPTION, IS_AUTHOR_CONDITION_OPTION],
              'Edit any data not covered by another action. This covers the following:\n\n- Edit name\n- Edit contents\n- Submit entry for review'
            ),
          ],
        },
        mockActionOption(
          PolicyAction.ARCHIVE,
          'Archive',
          [ALWAYS_CONDITION_OPTION, IS_AUTHOR_CONDITION_OPTION],
          'Archive and unarchive entries'
        ),
        mockActionOption(PolicyAction.RETRACT_REVIEW, 'Retract accepted entry from review', [
          ALWAYS_CONDITION_OPTION,
          IS_AUTHOR_CONDITION_OPTION,
        ]),
      ],
    },
    {
      __typename: 'ItemTypeOptionNode',
      itemType: PolicyItemType.OTHER,
      name: 'Other item types',
      description:
        'This covers any items not covered above. Currently these are:\n- Enzyme lists\n- Feature libraries\n- Ladders',
      actionOptions: [
        READ_ACTION_OPTION,
        mockActionOption(PolicyAction.WRITE, 'Edit', [ALWAYS_CONDITION_OPTION]),
        mockActionOption(
          PolicyAction.ARCHIVE,
          'Archive',
          [ALWAYS_CONDITION_OPTION],
          'Archive and unarchive items if archiving is supported'
        ),
        mockActionOption(PolicyAction.ADMIN, 'Admin', [ALWAYS_CONDITION_OPTION]),
      ],
    },
  ],
};

export const SCHEMA_POLICY_TEMPLATE: PolicyTemplateNode = {
  __typename: 'PolicyTemplateNode',
  itemTypeOptions: [
    {
      __typename: 'ItemTypeOptionNode',
      itemType: PolicyItemType.SCHEMA,
      name: 'Schema Definition ItemTypeOption',
      description: null,
      actionOptions: [READ_ACTION_OPTION, EDIT_ACTION_OPTION_GROUP],
    },
  ],
};
